import { LandingPage, PageIdType } from 'generated-graphql';
import { initializeApollo } from 'lib/apolloClient';
import BlockMix from '@/components/BlockMix/BlockMix';
import { getEntityBlocks } from 'gql/common/blocks';
import { getGlobalData } from 'lib/global';
import styles from "./Pov.module.scss"
import appConfig from '@/app.config';
import { MainParagraph, SecondaryTitle } from '@/componentsWP/StyledComponentsLib/StyledComponentsLib';
import dynamic from 'next/dynamic';
import Team from '@/componentsWP/Team/Team';
import Offices from '@/componentsWP/Offices/Offices';
import { useState } from 'react';
import Link from 'next/link';
import DivergentBoxes from '@/componentsWP/DivergentBoxes/DivergentBoxes';
import Content from '@/componentsWP/Content/Content';
import Collapse from '@/componentsWP/Collapse/Collapse';
import FullWidthImage from '@/componentsWP/FullWidthImage/FullWidthImage';
import ExpandableBoxes from '@/componentsWP/ExpandableBoxes/ExpandableBoxes';
import { GetServerSideProps } from 'next';
import SEO from '@/components/SEO/SEO';

const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });


export default function Home({
  pageBlocks,
}: {
  pageBlocks?: LandingPage;
}) {
  const [ready, setReady] = useState(false);
  return (

    <div className={styles.thisMachine}>

      <SEO
        title="Our point of view. - This Machine"
        description="Personally and professionally, it’s everyone’s job to show up in the moments that matter. We show up on our best days, and we show up when we’re tired and feeling less than inspired."
        og={{
          siteName: 'This Machine',
          image: `https://thismachine.agency/thismachine-cover.png`,
        }}
      />
      <div className={`${styles.header} ${styles.header2}`} >


        <div className={styles.contentWrapper}>
          <div className='container'>

            <div className={styles.content}>
              <h1 style={{ color: "#fff" }} className='m-auto mb-5'>The art of <br className='br' /> <span className={styles.showUp}>sh<img style={{ width: "40px" }} src='/images/tm-logo.gif' />wing</span> up.</h1>

              {/* <a href='/contact' className='cta d-lg-none mt-4'>Contact us</a> */}
            </div>

          </div>
        </div>
      </div>
      {/* <div id='work'>
        <BlockMix
          blocksData={pageBlocks?.editorBlocks}
          acfData={pageBlocks?.builder?.sections}
        />
      </div> */}
      <Content textLeftSmall='<h3>Our point <br class="br"> of view.</h3>'
        textRightBig='<p class="xl-xs">Personally and professionally, it’s everyone’s job to show up in the moments that matter.  We show up on our best days, and we show up when we’re tired and feeling less than inspired.</p> <p class="xl-xs">By showing up for others and for ourselves, we define and develop our character and purpose. The same is true for brands.</p>' />



      <Content titleBig='<h1>As marketers, it’s our responsibility to help brands show up -- to build trust and provide guidance.</h1>'
        textRightBig='<p class="pt-xl-5 pt-4 offset-xl-4 ps-xl-4">We’ve always known the funnel was an inaccurate metaphor for marketing. In reality, it’s not about a funnel or any conveniently shaped visual device. It’s about showing up.</p> 
        <p class=" offset-xl-4 ps-xl-4">Over the past three years at This Machine, we’ve found that showing up reflects a new and more valid way for us to create a meaningful dialogue between brands and people. And it’s a more accurate reflection of how we’ve been working with our partners, helping to explore and refine how brands show up in an ever-evolving, complex buyer’s journey.</p> 
        <p class="offset-xl-4 ps-xl-4">Brands must show up where buyers need them.</p> 
        <p class="offset-xl-4 ps-xl-4">Despite heroic attempts at designing full-funnel, customer-centric strategies, there are spaces where brands should appear but don’t. Organizations invest big money in brand awareness and direct acquisition efforts but miss the important in-betweens. These are critical buyer moments, and they are often the least considered and least connected.</p>
        ' />
      <Content image='/images/leftImg.png' textRight='<h2 class="pt-xl-0 pt-3">Why does this continue to happen?</h2> <p class="pt-xl-5 pt-3">Sometimes the obstacle to showing up in the moments that matter is organizational — marketing and sales aren’t set up to collaborate, let alone connect to each other’s efforts. Sometimes the obstacle is tribal — brand marketers think sales enablement sucks while sales folk think brand marketing is whimsical and wasteful.</p> <p>Meanwhile, customers have already moved on. They are taking their own idiosyncratic, self-guided journeys in a landscape where noise is at an all-time high. </p>' />

      <Content orderReverse='xl-0' image='/images/rightImg.png' textLeft='<h2 class="pt-xl-0 pt-3">They need you, but you aren’t there.</h2> <p class="pt-xl-5 pt-4"> Isn’t that what agencies are for, you might be asking? Most agencies aren’t designed to execute buyer-centric moments across every journey stage. Emotional branding is not built for the complex nature and pragmatic fluency of converting a sale. And the creators of sales materials aren’t likely to connect product truths to the emotional, brand-buyer affinity. This Machine is ready to help brands show up. </p> <p>At This Machine, we specialize in the art of showing up where your buyers need you.</p>' />

      <FullWidthImage text='<h3>A journey isn’t a funnel and it’s not a linear, step-by-step motion to a sale.</h3> <p class="pb-4">It’s complex, full of emotions, twists, turns and forks in the road. That’s why it’s important to understand it and to know how to show up at the right time, in the right place with the right message.</p>' />

      <div className='my-5 py-5'>
        <Collapse title='<h3>We observe and we listen.</h3>' text='<p>Our work blends research and investigation to understand the world around us and to define how we, as consumers and marketers, help brands identify the places you could and should show up for the buyer. Together with our partners, we create actionable plans for brands to have presence, relevance, and prominence in the moments that matter.</p>' />

        <Collapse title='<h3>We collaborate and we create.</h3>' text='<p>Our combined editorial and creative strategy identifies and connects the big picture to the bottom line in unique, newsworthy, and interesting ways. And we can navigate the complexity within marketing and sales teams to ensure cohesion and collaboration.</p>' />

        <Collapse title='<h3>We test and we refine.</h3>' text='<p>Our deployment strategy is designed for a holistic buyer experience, producing content and creative that can be modular and efficient for multiple channels and experiences throughout the buyer journey.</p>' />
      </div>
      <div style={{ background: "#0c2a31" }} id='about'>
      </div>

    </div>

  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  const apolloClient = initializeApollo();

  const pageBlocks = await apolloClient.query({
    query: getEntityBlocks(),
    variables: {
      id: 'this-machine-2',
      idType: PageIdType.Uri,
      asPreview: false,
    },
  });
  const pageProps = {
    pageBlocks: pageBlocks?.data?.page,
  };

  return await getGlobalData(pageProps, apolloClient);
}